import { AppBar, Container, makeStyles, MenuItem, Select, Toolbar, Typography,createTheme, ThemeProvider } from '@material-ui/core'
import { useNavigate } from 'react-router-dom';
 import { CryptoState } from '../CryptoContext';

const useStyles= makeStyles({
  title: {
    flex:1,
    color:'gold',
    fontWeight:'bold',
    cursor:'pointer'
  },
})
const darkTheme = createTheme({
  palette: {
    primary:{
      main: '#fff'
    },
    type: 'dark',
  },
});

const Header = () => {
  const classes=useStyles();
  const navigate = useNavigate();
  const {currency,setcurrency,symbol}=CryptoState();
  console.log(currency);

  return (
    <>
    <ThemeProvider theme={darkTheme}>
     <AppBar color='transparent' position='static' >
      <Container>
        <Toolbar>
          <Typography className={classes.title} onClick={()=>{navigate('/')}} > Crypto Tracker </Typography>
          <Select  value={currency} onChange={(e)=>{setcurrency(e.target.value)}} variant='outlined' style={{width:'100px', height:'40px',marginRight:'15px'} }>
          <MenuItem value={'PKR'}>PKR {symbol}</MenuItem>
          <MenuItem value={'USD'} >USD {symbol} </MenuItem>
          </Select>
        </Toolbar>
      </Container>
     </AppBar>
     </ThemeProvider>
    </>
  )
}

export default Header